/*
 * @Author: hansu
 * @Date: 2026-08-21 09:52:05
 * @LastEditors: hansu
 * @LastEditTime: 2026-08-21 09:56:37
 * @Description: 动态加载天地图 JS API，防止重复加载
 */
let tdtScriptPromise = null;

/**
 * 加载天地图脚本
 * @param {string} key - 天地图 Key
 * @returns {Promise<void>}
 */
export function loadTdtMapScript(key) {
  if (window.T) {
    return Promise.resolve();
  }
  if (tdtScriptPromise) {
    return tdtScriptPromise;
  }
  tdtScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${key}`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('天地图 API 脚本加载失败'));
    document.head.appendChild(script);
  });
  return tdtScriptPromise;
}

/**
 * 轮询等待天地图 T 变量就绪
 * @param {Function} callback
 * @param {number} interval
 */
export function waitForTMap(callback, interval = 100) {
  if (window.T) {
    callback();
    return;
  }
  const timer = setInterval(() => {
    if (window.T) {
      clearInterval(timer);
      callback();
    }
  }, interval);
}

/**
 * 判断天地图是否已加载
 * @returns {boolean}
 */
export function isTiandituLoaded() {
  return !!window.T;
}
